import type { ContractorUser } from "@/hooks/queries/useMe";
import { isMobile } from "@/utils/is-mobile";
import CollapsibleNavSection from "@/pages/homepage/components/common/CollapsibleNavSection";
import AccountLinksList from "./AccountLinksList";
import MobileNavLinks from "./MobileNavLinks";

export default function ContractorMobileDrawerContent({
  user,
  onClose,
}: ContractorMobileDrawerContentProps) {
  const isMobileView = isMobile();

  return (
    <div className="flex flex-col gap-2 pt-1 pb-4">
      <CollapsibleNavSection label="My Account"
        classNames={{
          trigger: "p-4 pb-1 pt-0",
        }}>
        <AccountLinksList
          links={user.accountLinks}
          onClose={onClose}
          variant="nested"
          classNames={{ link: "text-base" }}
        />
      </CollapsibleNavSection>

      {isMobileView && <MobileNavLinks />}
    </div>
  );
}

interface ContractorMobileDrawerContentProps {
  user: ContractorUser;
  onClose: () => void;
}

